module.exports = __webpack_public_path__ + "img/tagline.4851d253.png";